import { Component, h, Host } from "@stencil/core";

@Component({
    tag: "ux-slider-slide",
    styleUrl: "slider-slide.scss",
    shadow: false
})
export class Slide {
    render() {
        return (
            <Host class="ux-slider-slide">
                <slot />
            </Host>
        );
    }
}
